import {Box, Typography} from '@mui/material';
import {ReactComponent as ArrowBack} from '../../assets/images/arrow-back.svg';
import {t} from 'i18next';

interface ExpandBannerProps {
  onExpandClick?: () => void;
  dataTestId?: string;
  className?: string;
}
export const ExpandBanner = ({
  onExpandClick,
  className,
  dataTestId = '',
}: ExpandBannerProps) => {
  return (
    <Box
      className={`expand-banner ${className}`}
      data-testid={dataTestId}
      gap={2}
      onClick={onExpandClick}
    >
      <ArrowBack />
      <Typography className={'type-text label4_size'} data-testid={`expand-banner-expand`}>
        {t('docView.expand')}
      </Typography>
      <ArrowBack />
    </Box>
  );
};
